import React from 'react';
import { Tile, Button } from '@op/opds.opux';
import { Message } from '@messageformat/react';
import Parser from 'html-react-parser';
import { savingsAccountUrl } from '../common';

interface Props {
  message: string;
  Image: React.FC<React.SVGProps<SVGSVGElement>>;
  showSavingsLink?: boolean;
}

const AdditionalRecommendation = (props: Props): JSX.Element => {
  const { message, Image, showSavingsLink } = props;
  return (
    <Tile style={{ flexGrow: 1, minHeight: '440px' }}>
      <div style={{ paddingTop: '40px' }}>
        <Image style={{ height: '200px', display: 'block', margin: 'auto' }} />
      </div>
      <p style={{ textAlign: 'center', paddingTop: '60px' }}>{Parser(message)}</p>
      {showSavingsLink && (
        <div style={{ textAlign: 'center' }}>
          <Button href={savingsAccountUrl} style={{ marginTop: '30px' }}>
            <Message id="additionalRecommendation_bankSavingInfo" />
          </Button>
        </div>
      )}
    </Tile>
  );
};

AdditionalRecommendation.defaultProps = {
  showSavingsLink: false,
};

export default AdditionalRecommendation;
